// extracted by mini-css-extract-plugin
export default {"root":"hcx-invitations-block_root__FACuI","buttonClose":"hcx-invitations-block_buttonClose__kxxXT","colorBlue":"hcx-invitations-block_colorBlue__CeUlx"};